export default {
    filters: {
        centsToDollars: function (value) {
            if (!value) return "";
            return value / 100;
        },
    },
};
